import { MapToolbarState, ReferenceLayerToolbarEntry } from '../types/map.types';

export interface ReferenceLayerGroup { name: string; entries: ReferenceLayerToolbarEntry[]; }

/** True when at least one row carries a published catalog group. */
export function hasPublishedGroups(state: MapToolbarState): boolean {
  return state.overlayLayers.some(entry => !!entry.group);
}

/**
 * Rows grouped for display, filtered by a search query. Published rows keep
 * manifest order; a legacy-only list keeps its last-added-on-top order.
 */
export function groupReferenceLayers(state: MapToolbarState, query = ''): ReferenceLayerGroup[] {
  const needle = query.trim().toLocaleLowerCase();
  const entries = [...state.overlayLayers];
  if (!hasPublishedGroups(state)) entries.reverse();
  const groups = new Map<string, ReferenceLayerToolbarEntry[]>();
  for (const entry of entries) {
    if (needle && !entry.name.toLocaleLowerCase().includes(needle)) continue;
    const name = entry.group || 'Other layers';
    groups.set(name, [...(groups.get(name) || []), entry]);
  }
  return Array.from(groups, ([name, rows]) => ({ name, entries: rows }));
}
